const Advert = require('./advert');

class AdvertOldTypeFour extends Advert {
  constructor() {
    super();
    this.data;
    this.ex;
    this.admData;
    this.GD_params;
    this.DOM;
    this.TEXT_TOP_GID = 1335; // id: 1335,836
    this.TEXT_MIDDLE_GID = 1336; // id: 1336,837
    this.TEXT_BOTTOM_GID = 1337; // id: 1337,838
  }

  SetDOM() {
    const content = $('div.article-content').first();
    const adms = this.data.adms[ 0 ];
    const platformId = adms.platformId;
    const adpType = this.data.adpType;
    const adpId = this.data.adpId;
    const admId = adms.admId;
    const admHighSpeed = adms.highSpeed;
    const gameId = adms.gameId;
    const url = adms.url;
    const imgUrl = adms.imageSrc;

    const callReserveNumberAndRepleceHtml = function(gameId, html, callback) {
      let resultHtml = '';
      $.ajax({
        url: '/tpl/android_new/gamedetail/netgame/block/yuyue_total_ajax.html',
        type: 'get',
        data: {
          gameId,
        },
        dataType: 'html',
        success(reserveNum) {
          resultHtml = html.replace(/\$预约人数/g, reserveNum).replace(/\$游戏ID/g, gameId);
          callback(resultHtml);
        },
        error(e) {
          console.log('广告位预约人数获取错误!', e.statusText);
        }
      });
    };
    const html = adms.htmlCode;
    const doAppendHtml = (html) => {
      if (typeof html !== 'undefined' && html !== null && html !== '') {
        if (this.TEXT_TOP_GID === adpId) {
          const review = $('div.art-review').first();
          if (typeof review !== 'undefined' && review !== null && review.length > 0) {
            this.DOM = $(`<div>${html}</div>`);
            this.initPullUp();
            this.SetStateEvent();
            $(review).after(html);
          } else {
            this.DOM = $(`<div>${html}</div>`);
            this.initPullUp();
            this.SetStateEvent();
            $(content).prepend(html);
          }
        } else if (this.TEXT_MIDDLE_GID === adpId) {
          const children = [];
          content.find('p').each(function(i, e) {
            if (typeof $(e).attr('style') === 'string') return;
            children.push(e);
          });
          const midChild = children[Math.round(children.length / 2 - 1)];
          this.DOM = $(`<div>${html}</div>`);
          this.initPullUp();
          this.SetStateEvent();
          $(midChild).after(this.DOM);
        } else if (this.TEXT_BOTTOM_GID === adpId) {
          this.DOM = $(`<div>${html}</div>`);
          this.initPullUp();
          this.SetStateEvent();
          $(content).append(this.DOM);
        }
      }
    };
    if (html.match(/\$预约人数/)) {
      // 异步获取预约人数并进行替换
      callReserveNumberAndRepleceHtml(gameId, html, doAppendHtml);
      // dom填充后，将预约拉起库加入。
      // const myScript = document.createElement('script');
      // myScript.type = 'text/javascript';
      // myScript.src = '../public/javascripts/android_new/appointment.js';
      // document.body.appendChild(myScript);
      // 模板 4999 / 4957 / 15268 会有可能用到。但是运营那边没有查到相关数据，原来使用appointment的专区也已经把相关逻辑都下线了。
      // appointment.js统一更新了引用 https://cdn.9game.cn/ngm-portal-jws/js/appointment.js
    } else {
      doAppendHtml(html);
    }
  }

  initPullUp() {
    this.DOM.find('[sign="highSpeed"]').on('click', (e) => {
      this.pullUp(this.admData.gameId, `ag_ugt-seo-nrzrgg-zx_${this.GD_params.odId}-gd_${this.admData.adpId}-wl_${this.admData.admId}-gid_${this.admData.gameId}`, 'KD_803', this.gameBaseInfo.packageproperty);
    });
  }
}

module.exports = AdvertOldTypeFour;


// WEBPACK FOOTER //
// ./lib/js/module/m_advert/module/advert_old_type_four.js